import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtSuperGroupItem {
    tenantId: number;
    superGroupId: number;
    superGroupDefaultInitials: string;
    superGroupDefaultShortName: string;
    superGroupDefaultName: string;
    clientTranslationTextId: number;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
    languageID: number;
}

export interface SuperGroupItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
    enabled: boolean;
}

class SuperGroupItemModelTransformer
    implements ModelTransformer<SuperGroupItem, ExtSuperGroupItem>
{
    transform(model: ExtSuperGroupItem): SuperGroupItem {
        return {
            id: model.superGroupId,
            initials: model.superGroupDefaultInitials,
            shortName: model.superGroupDefaultShortName,
            name: model.superGroupDefaultName,
            enabled: model.enabled,
        };
    }
}

export class SuperGroupItemModelSetTransformer extends ModelSetTransformer<
    SuperGroupItem,
    ExtSuperGroupItem
> {
    protected newTransformer(): ModelTransformer<
        SuperGroupItem,
        ExtSuperGroupItem
    > {
        return new SuperGroupItemModelTransformer();
    }
}

export function validateSuperGroup(model: SuperGroupItem[]): void {
    const valid = model != null && model.length !== 0;
    if (!valid) {
        throw new Error('SuperGroup not valid');
    }
}
